import React from 'react'
const Loader = () => {
    return (
        <div>
            <font color="white">
                <center> By Debtanu | <a href="https://github.com/Decoder6125">Decoder6125</a></center>
            </font>
        </div>
    )
}

export default Loader
